import React from "react";

function barColor(percentage: number): string {
  if (percentage >= 90) return "var(--color-error)";
  if (percentage >= 70) return "var(--color-warning)";
  return "var(--color-accent)";
}

export const QuotaProgressBar: React.FC<{
  percentage: number;
  size?: "sm" | "md";
}> = ({ percentage, size = "sm" }) => (
  <div
    className={`w-full ${size === "md" ? "h-1.25" : "h-0.75"} rounded-app overflow-hidden`}
    style={{ background: "var(--color-bg)" }}
  >
    <div
      className="h-full rounded-app"
      style={{
        width: `${Math.min(100, Math.max(0, percentage))}%`,
        background: barColor(percentage),
        transition: "width 200ms ease-in-out",
      }}
    />
  </div>
);
